import { createContext, useContext, useState, useCallback, useMemo } from "react";

const ProcessingContext = createContext(null);

export function ProcessingProvider({ children }) {
  const [state, setState] = useState({ active: false, message: "" });

  const start = useCallback((message = "Trabalhando pra você...") => {
    setState({ active: true, message });
  }, []);
  const update = useCallback((message) => {
    setState((s) => ({ ...s, message: message || s.message }));
  }, []);
  const stop = useCallback(() => {
    setState({ active: false, message: "" });
  }, []);

  const value = useMemo(
    () => ({ ...state, start, update, stop }),
    [state, start, update, stop]
  );

  return <ProcessingContext.Provider value={value}>{children}</ProcessingContext.Provider>;
}

export const useProcessing = () => useContext(ProcessingContext);
